import { endOfDay } from 'date-fns';
import { FirestoreDataConverter } from 'firebase/firestore';
import { Goal, NewGoal } from 'shared/types/goal';
import { MetricEntryMode } from 'shared/types/goal-metric';

import { firebaseObjectTimestampToDate } from './firebase-timestamp-to-date';

export const goalConverter: FirestoreDataConverter<Goal> = {
  fromFirestore: (snapshot) => {
    const data = firebaseObjectTimestampToDate(snapshot.data());

    return {
      ...data,
      startDate: data.startDate ?? null,
      updatedAt: data.updatedAt ?? null,
      deadline: data.deadline ?? null,
      completedAt: data.completedAt ?? null,
      createdAt: data.createdAt ?? new Date(),
      archivedAt: data.archivedAt ?? null,
      frozenAt: data.frozenAt ?? null,
      iconName: data.iconName ?? null,
      image: data.image ?? null,
      metric: data.metric
        ? {
            ...data.metric,
            startValue:
              typeof data.metric.startValue === 'number'
                ? Math.round(data.metric.startValue * 100) / 100
                : null,
            targetValue:
              typeof data.metric.targetValue === 'number'
                ? Math.round(data.metric.targetValue * 100) / 100
                : null,
            entries:
              // @ts-ignore -- entries type not recognized
              data.metric.entries?.map(({ value, mode, ...entry }) => ({
                ...entry,
                value: Math.round(value * 100) / 100,
                mode: mode ?? MetricEntryMode.Absolute,
              })) ?? null,
          }
        : null,
      sections: data.sections ?? null,
    } as Goal;
  },
  toFirestore: (goal) => goal,
};

export const newGoalConverter = (goal: NewGoal) => ({
  ...goal,
  createdAt: new Date(),
  image: goal.image ?? null,
  lifeAreaId: goal.lifeAreaId ?? null,
  frozenAt: null,
  startDate: goal.startDate ? new Date(goal.startDate) : null,
  deadline: goal.deadline ? endOfDay(goal.deadline) : null,
  parentIds: goal.parentIds?.length
    ? Array.from(new Set(goal.parentIds))
    : null,
  completedAt: null,
  archivedAt: null,
});
